var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","fill":"#fff","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2 9.7v7.05l-4.31-2.54V9.13L0 0h16.45L10.2 9.7Z"})),React.createElement("path",{"d":"m10.2 9.7-.84-.55-.16.25v.3h1Zm0 7.05-.51.86 1.5.89v-1.75h-1Zm-4.31-2.54h-1v.57l.5.3.5-.87Zm0-5.08h1v-.3l-.16-.24-.84.54ZM0 0v-1h-1.84l1 1.54L0 0Zm16.45 0 .84.54 1-1.54h-1.84v1ZM9.2 9.7v7.05h2V9.7h-2Zm1.5 6.19-4.3-2.54-1.02 1.72 4.31 2.54 1.02-1.72ZM6.9 14.2V9.13h-2v5.08h2ZM6.73 8.6.84-.54-.84.54l5.89 9.13L6.73 8.6ZM0 1h16.45v-2H0v2ZM15.61-.54l-6.25 9.7 1.68 1.08 6.25-9.7-1.68-1.08Z","fill":"currentColor","mask":"url(#a)","key":1})]);
}

Filter.defaultProps = {"fill":"none","viewBox":"0 0 17 17"};

module.exports = Filter;

Filter.default = Filter;
